import { NgModule } from "@angular/core";
import { AllowedRegExpDirective } from "./allowed-reg-exp.directive";
import { BindQueryParamsToFormDirective } from "./bind-query-params-form.directive";
import { GenericContentDirective } from "./content.directive";
import { OnlyNumbersDirective } from "./only-numbers.directive";

@NgModule({
  declarations: [AllowedRegExpDirective, BindQueryParamsToFormDirective, OnlyNumbersDirective, GenericContentDirective],
  exports: [AllowedRegExpDirective, BindQueryParamsToFormDirective, OnlyNumbersDirective, GenericContentDirective],
})
export class DirectivesModule {}
